module.exports = __webpack_public_path__ + "static/media/22.8328847f.png";